module.exports = __webpack_public_path__ + "static/img/235.79a7e48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/200921/235.jpg
// module id = H6c8
// module chunks = 0